import { provideEffects } from '@ngrx/effects';
import { routerReducer } from '@ngrx/router-store';
import { provideState } from '@ngrx/store';

import { oivCoreSharedFeature } from './core-shared/oiv-core-shared.reducer';
import { TealiumTrackingEffects } from './tealium-tracking/tealium-tracking-effects.service';

export const provideOivCoreSharedStore = [
    provideState({
        name: 'router',
        reducer: routerReducer,
    }),
    provideState({
        name: oivCoreSharedFeature.name,
        reducer: oivCoreSharedFeature.reducer,
    }),
    provideEffects(TealiumTrackingEffects),
];
